import { Button, Carousel, Col, Row } from "react-bootstrap"
import { url_images } from "../../lib/backend/data"
import { validateEmail } from "../../lib/helpers/helpers"
import { useState } from "react"

const { useSelector } = require("react-redux")

const NewletterSite = props => {
    const sitio = useSelector(state => state.sitio)
    const [ email, setEmail ] = useState("")
    const [ validated, setValid ] = useState(false)
    const [ sended, setSended ] = useState(false)
    const [ error, setError ] = useState(null)

    if(sitio.modules?.newsletter_footer?.active !== true) return null
    if(!sitio.modules?.newsletter_footer?.items?.email?.value) return null
    if(!sitio.modules?.newsletter_footer?.items?.lista?.value) return null

    const enviarEmail = () => {
        setError(null)
        if(!validated) return setError("Email inválido")
        setSended(true)
    }
    
    const handleChange = (e) => {
        const val = e.target.value
        const valid = validateEmail(val)
        setEmail(val)
        setValid(valid)
    }

    
    return <div>
        <Row className="align-items-center justify-content-center">
            <Col md={6} xs={12}>
            <h6 className="mb-0"><b>{sitio.modules?.newsletter_footer?.items?.title || "Suscríbete para recibir información exclusiva"}</b></h6>
            <p className="mb-0">Promociones, noticias y mucho más...</p>
            </Col>
            <Col md={6} xs={12}>
            <Row>
                <Col xs={8}><input className="form-control mb-2" disabled={sended} placeholder="Escribe tu email" onChange={handleChange} /></Col>
                <Col xs={4}>{sended ? <Button className="w-100" disabled>Enviado</Button> : <Button className="w-100" onClick={() => enviarEmail()}>Enviar</Button>}</Col>
                {error ? <Col xs={12}><p className="text-danger">{error}</p></Col> : null}
            </Row>
            </Col>
        </Row>
    </div>
}

export default NewletterSite